var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotInvitedWorker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "not-invited",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#1F86E8",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#FFFFFF",
    points: "15.875 9.125 15.875 10.875 4.125 10.875 4.125 9.125"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInvitedWorker);
export default __webpack_public_path__ + "static/media/not-invited-worker.46b258620724f5797d4d5cabb85b80be.svg";
export { ForwardRef as ReactComponent };